import {Component, input} from '@angular/core';
import {TranslocoDirective} from "@jsverse/transloco";
import {PillColor, PillLogoComponent, Size} from "shared-lib";

@Component({
  selector: 'app-fourth-page',
  imports: [
    TranslocoDirective,
    PillLogoComponent
  ],
  templateUrl: './fourth-page.component.html',
  styleUrl: './fourth-page.component.scss'
})
export class FourthPageComponent {
  protected pillColor = PillColor
  companyName = input.required<string>();
  cashbackPercent = input<number>();
  companyLogo = input.required<string>();
  protected readonly Size = Size;
}
